import React, { Component } from "react"
import Helmet from "react-helmet"
class HelmetScript extends Component {
  render() {
    return (
      <>
        <Helmet>
          <meta
            name="ahrefs-site-verification"
            content="51f402649d382002e885b5566963593dfca6a236cfec2f9416c0cd7c20bc655e"
          ></meta>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=AW-674518366"
          ></script>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=UA-154001824-1"
          ></script>
          <script async>
            {`
            <!-- Twitter universal website tag code -->

            !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
            },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
            a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
            // Insert Twitter Pixel ID and Standard Event data below
            twq('init','o4056');
            twq('track','PageView');

            <!-- End Twitter universal website tag code -->
            <!-- Facebook Pixel Code -->
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '2617691145174654');
            fbq('track', 'PageView');

            <!-- End Facebook Pixel Code -->
            <!-- Start of Drift Code -->
            "use strict";
              !function() {
                var t = window.driftt = window.drift = window.driftt || [];
                if (!t.init) {
                  if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
                  t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ], 
                  t.factory = function(e) {
                    return function() {
                      var n = Array.prototype.slice.call(arguments);
                      return n.unshift(e), t.push(n), t;
                    };
                  }, t.methods.forEach(function(e) {
                    t[e] = t.factory(e);
                  }), t.load = function(t) {
                    var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                    o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
                    var i = document.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(o, i);
                  };
                }
              }();
              drift.SNIPPET_VERSION = '0.3.1';
              drift.load('62xyyay9gmru');
              <!-- End of Drift Code -->

              <!-- Google Tag Manager -->
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MMVB2MC');
<!-- End Google Tag Manager -->

              window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'AW-674518366');
                var formName = localStorage.getItem("formName");
                var formData = localStorage.getItem("formData");
                if (formName) {
                  gtag('event', 'page_view', {
                    'send_to': 'AW-674518366',
                    'email': formData && formData.email ? formData.email : '',
                    'items': [{
                    'Full Name': formData && formData.first_name ? formData.first_name : '' + formData && formData.last_name ? formData.last_name : ''
                    }]
                  });
                  // localStorage.removeItem("formName");
                }
              <!-- End of gtag management function -->
              
              <!-- Start of segment function -->
              var user_id = localStorage.getItem("ajs_anonymous_id");
              function getQueries() {
                <!-- Get all URL params -->
                var urlParams = new URLSearchParams(window.location.search);
                var entries = urlParams.entries();
                var traits = [];
                <!-- Create array for each params separately -->
                for (var pair of entries) {
                  if (pair[0].indexOf("sl_") === 0 || pair[0].indexOf("utm_") === 0) {
                    traits.push(pair);
                  }
                }
                var queryParameters = traits.reduce(function(map, obj) {
                  map[obj[0]] = obj[1];
                  return map;
                }, {});
                return queryParameters
              }

              let getQueriesObj = getQueries()
              var formValue = {
                sl_email: getCookie("utm_medium"),
                sl_company: getCookie("sl_companyName"),
                sl_fullname: getCookie("sl_userName")
              };
          
              var pathname = window.location.pathname;
              var traitsObj = { ...getQueriesObj, ...formValue };
              function getCookie(name) {
                var pattern = RegExp(name + "=.[^;]*");
                var matched = document.cookie.match(pattern);
                if (matched) {
                  var cookie = matched[0].split("=");
                  return cookie[1];
                }
                return "";
              }
              var formName = localStorage.getItem("formName");
              var formData = localStorage.getItem("formData");
              !(function() {
                var analytics = (window.analytics = window.analytics || []);
                if (!analytics.initialize)
                  if (analytics.invoked)
                    window.console &&
                      console.error &&
                      console.error("Segment snippet included twice.");
                  else {
                    analytics.invoked = !0;
                    analytics.methods = [
                      "trackSubmit",
                      "trackClick",
                      "trackLink",
                      "trackForm",
                      "pageview",
                      "identify",
                      "reset",
                      "group",
                      "track",
                      "ready",
                      "alias",
                      "debug",
                      "page",
                      "once",
                      "off",
                      "on"
                    ];
                    analytics.factory = function(t) {
                      return function() {
                        var e = Array.prototype.slice.call(arguments);
                        e.unshift(t);
                        analytics.push(e);
                        return analytics;
                      };
                    };
                    for (var t = 0; t < analytics.methods.length; t++) {
                      var e = analytics.methods[t];
                      analytics[e] = analytics.factory(e);
                    }
                    analytics.load = function(t, e) {
                      var n = document.createElement("script");
                      n.type = "text/javascript";
                      n.async = !0;
                      n.src =
                        "https://cdn.segment.com/analytics.js/v1/" +
                        t +
                        "/analytics.min.js";
                      var a = document.getElementsByTagName("script")[0];
                      a.parentNode.insertBefore(n, a);
                      analytics._loadOptions = e;
                    };
                    analytics.SNIPPET_VERSION = "4.1.0";
                    analytics.load("G5ORvQLPalmVrPQihFEzHFObVrof3Ban");
                    analytics.identify(getCookie("_ga"), traitsObj);
                    analytics.page(pathname);
                    if (formName) {
                      analytics.track(formName, JSON.parse(formData));
                      localStorage.removeItem("formName");
                      localStorage.removeItem("formData");
                    }
                  }
              })();
              <!-- End of Segment function -->

              <!-- Start Clearbit function -->
                !(function(w) {
                var clearbit = (w.clearbit = w.clearbit || []);
                if (!clearbit.initialize)
                    if (clearbit.invoked)
                    w.console &&
                        console.error &&
                        console.error("Clearbit snippet included twice.");
                    else {
                    clearbit.invoked = !0;
                    clearbit.methods = [
                        "trackSubmit",
                        "trackClick",
                        "trackLink",
                        "trackForm",
                        "pageview",
                        "identify",
                        "reset",
                        "group",
                        "track",
                        "ready",
                        "alias",
                        "page",
                        "once",
                        "off",
                        "on"
                    ];
                    clearbit.factory = function(t) {
                        return function() {
                        var e = Array.prototype.slice.call(arguments);
                        e.unshift(t);
                        clearbit.push(e);
                        return clearbit;
                        };
                    };
                    for (var t = 0; t < clearbit.methods.length; t++) {
                        var e = clearbit.methods[t];
                        clearbit[e] = clearbit.factory(e);
                    }
                    clearbit.load = function(t) {
                        var e = document.createElement("script");
                        e.async = !0;
                        e.src =
                        ("https:" === document.location.protocol
                            ? "https://"
                            : "http://") +
                        "x.clearbitjs.com/v1/" +
                        t +
                        "/clearbit.js";
                        var n = document.getElementsByTagName("script")[0];
                        n.parentNode.insertBefore(e, n);
                    };
                    clearbit.SNIPPET_VERSION = "3.1.0";
                    clearbit.load("pk_21acff98831c2b583ddb56380df85c51");
                    clearbit.page();
                    
                    getQueriesObj && getQueriesObj.sl_email && getQueriesObj.sl_companyName ? clearbit.identify(getCookie("_ga"), {
                      email: getQueriesObj.sl_email,
                      company: getQueriesObj.sl_companyName
                    }) : getQueriesObj && getQueriesObj.sl_email ? clearbit.identify(getCookie("_ga"), {
                      email: getQueriesObj.sl_email
                    }) : null
                  }
                })(window);
                <!-- End Clearbit function -->
            `}
          </script>
        </Helmet>

        {/* <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-MMVB2MC"
            height="0"
            width="0"
            style="display:none;visibility:hidden"
          ></iframe>
        </noscript> */}
      </>
    )
  }
}

export default HelmetScript
